module.exports = __webpack_public_path__ + "static/media/map.0ec59cec.png";